import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";

import { IMsalContext } from "../../authentication/MsalContext";
import { useMsal } from "../../authentication/MsalProvider";
import { Auction, useAuction } from "../../services/AuctionService";
import { LoadingComponent } from "../loading/LoadingComponent";
import VehicleViewLot from "./vehicle-lot/VehicleViewLot";

interface VehicleAuctionContainerProps {
  auctionId: string;
}

const ViewLotComponent: React.FC<VehicleAuctionContainerProps> = ({ auctionId }) => {
  const msal: IMsalContext = useMsal();
  const { enqueueSnackbar } = useSnackbar();

  const [auction, auctionLoading] = useAuction(auctionId, msal.accounts.length > 0, () => {
    enqueueSnackbar('There was a problem loading the auction, please try again.', { variant: "error" });
  });



  const [auctionWithReg, setAuctionWithReg] = useState<Auction>();

  useEffect(() => {
    if (auction) {
      setAuctionWithReg({ ...auction });
    }
  }, [auction]);

  if (!auctionWithReg || auctionLoading) {
    return <LoadingComponent label="Loading Auction" />;
  }

  return <VehicleViewLot auction={auctionWithReg} />;
};

export default ViewLotComponent;
